import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useSettings } from "../contextapi/SettingsContext";
import { Loader } from "./Loader/loader";
import { Step1 } from "./StepperSteps/Step1";
import { Step2 } from "./StepperSteps/Step2";
import { useStepperForm } from "./StepperSteps/hooks/useStepperForm";
import { useFormSubmission } from "./StepperSteps/hooks/useFormSubmission";
import {
  runValidations,
  createValidationSchemas,
  createPaidValidationSchema,
} from "./StepperSteps/utils/validation";

export const ParentStepper = ({
  onHide,
  fetchFeaturedMockups,
  editlistdata,
  mocko_id,
}) => {
  const { minimumPrice } = useSettings();
  const [step, setStep] = useState(1);
  const [canvas, setCanvas] = useState(null);

  const {
    stepperFormdata,
    setStepperFormdata,
    handleChange,
    fieldErrors,
    setFieldErrors,
  } = useStepperForm(editlistdata);

  const { handelSubmit, loader } = useFormSubmission(
    stepperFormdata,
    mocko_id,
    fetchFeaturedMockups,
    onHide
  );

  const validationSchema = createValidationSchemas();

  const nextStep = () => {
    let currentSchema1 = 
      step === 2 && !stepperFormdata.is_free
        ? createPaidValidationSchema(minimumPrice)
        : validationSchema[step - 1];

    const { success, validationErrors } = runValidations(
      currentSchema1,
      stepperFormdata
    );

    if (!success) {
      return setFieldErrors(validationErrors);
    }

    if (step === 2) {
      handelSubmit();
    } else {
      setStep(step + 1);
    }
  };

  const prevStep = () => {
    setStep(step === 1 ? step : step - 1);
  };

  return (
    <div className="container-fluid" style={{ backgroundColor: "#FDFAF1" }}>
      <Loader loading={loader} />
      <div
        className="container d-flex align-items-center justify-content-center px-sm-2 px-0"
        style={{
          minHeight: "auto",
          backgroundColor: "#FDFAF1",
          paddingTop: "80px",
          paddingBottom: "80px",
        }}
      >
        <div
          className="w-100 rounded-5"
          style={{
            backgroundColor: "#FDFAF1",
            minHeight: "auto",
            marginBottom: "0px",
          }}
        >
          <div className="p-2">
            {step === 1 && (
              <Step1
                fieldErrors={fieldErrors}
                stepperFormdata={stepperFormdata}
                handleChange={handleChange}
                setCanvas={setCanvas}
                canvas={canvas}
                setStepperFormdata={setStepperFormdata}
                step={step}
                nextStep={nextStep}
              />
   
            )}

            {step === 2 && (
              <Step2
                fieldErrors={fieldErrors}
                stepperFormdata={stepperFormdata}
                handleChange={handleChange}
                setStepperFormdata={setStepperFormdata}
                minimumPrice={minimumPrice}
              />
            )}
          </div>
          {step === 2 && (
            <div className="d-flex flex-column flex-md-row gap-2 justify-content-end pe-4">
              <Button
                onClick={() => prevStep()}
                className="grey-btn"
              >
                Previous
              </Button>
              <Button
                onClick={() => nextStep()}

                className="red-btn"
              >
                Publish
              </Button>
              <Button
                onClick={() => {
                  setStepperFormdata((prev) => ({
                    ...prev,
                    is_published: false,
                  }));
                  nextStep();
                }}
      
                className="red-btn"
              >
                Save as Draft
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
